import styled from 'styled-components';

export const Container = styled.div`
  margin: 1rem 0;

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-direction: column;

  .containerDropdown {
    display: grid;
    grid-template-columns: 45% 45%;
    justify-content: space-between;
    padding: 0;
    margin-bottom: 1rem;
  }

  .containerCitiesSuggested {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${({ theme }) => theme.colors.tertiary_500};

    .contentCities {
      display: flex;
      flex-wrap: wrap;
      max-height: 5rem;
      overflow-y: auto;
      gap: 1rem;
      margin-top: 1rem;

      .notSelected {
        border: 1px solid ${({ theme }) => theme.colors.primary};
        border-radius: 2rem;
        padding: 0.1rem 1rem;
      }

      .selected {
        color: ${({ theme }) => theme.colors.background_white};
        background: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.primary};
        border-radius: 2rem;
        padding: 0.1rem 1rem;
      }
    }

    .containerButtons {
      display: flex;
      justify-content: flex-end;
      margin: 1rem 0;
      gap: 1rem;

      .MuiButton-root {
        padding: 0.1rem 0.5rem;
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.tertiary_500};
        font-weight: 300;
        border-radius: 1rem;
      }
    }
  }

  .containerCitites {
    display: flex;
    flex-direction: column;

    h2 {
      margin: 1rem 0 0 0;
    }

    .contentCities {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
      max-height: 10rem;
      overflow-y: auto;

      .cities {
        display: flex;
        align-items: center;
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.background_white};
        border-color: transparent;
        font-size: 1.1rem;
        padding: 0.4rem 0.4rem;
        border-radius: 0.5rem;
        margin-top: 0.5rem;

        button {
          cursor: pointer;
          color: ${({ theme }) => theme.colors.primary};
          background: ${({ theme }) => theme.colors.yellow_200};
          width: 20px;
          height: 19px;
          border-radius: 100%;
          padding: 0;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0.5rem;

          svg {
            font-size: 1.1rem;
          }
        }
      }
    }
  }

  @media (max-width: 1000px) {
    .containerDropdown {
      grid-template-columns: 45% 45%;
      gap: 4rem;
    }
  }

  @media (max-width: 700px) {
    .containerDropdown {
      gap: 3rem;
    }
  }

  @media (max-width: 500px) {
    .containerDropdown {
      display: flex;
      flex-direction: column;
    }
  }
`;
